















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class Select extends Vue {
  @Prop()
  name: string;

  @Prop()
  label: string;

  @Prop()
  classes: string[];

  @Prop()
  selectedItemKey: {};

  @Prop()
  items: string[];

  @Prop()
  disabled: boolean;

  @Prop()
  onChange: (item: object) => void;

  showOptions = false;
  selectedItem = null;

  beforeMount () {
    if (!this.selectedItemKey && this.items.length > 0) {
      this.selectedItem = this.items[0];
    } else {
      this.selectedItem = {
        key: -1,
        value: ""
      };
    }
  }

  toggleOptions () {
    this.showOptions = !this.showOptions;
  }

  selectOption (item) {
    this.selectedItem = item;
    this.toggleOptions();
    this.onChange(item);
  }
}

